module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/hero@2x.10700a4.png";